(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('semeaduraTratamento', RecomendacaoSemeaduraTratamentoTab);

  function RecomendacaoSemeaduraTratamentoTab() {
    return {
      restrict: 'E',
      bindToController: true,
      controller: 'RecomendacaoSemeaduraTratamentoCtrl',
      controllerAs: 'tratamentoSemeadura',
      templateUrl: 'views/recomendacao_semeadura/tabs/tratamento_tab.html',
      scope: {
        recomendacao: '=recomendacao',
        isCorn: '=isCorn',
        cultivaresTratamento: '=cultivaresTratamento',
        cultivaresDestinoTratamento: '=cultivaresDestinoTratamento'
      }
    };
  }
}());
